import {
	IconArrowDownOutline18 as ArrowDown,
	IconArrowUpOutline18 as ArrowUp,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

interface SortableTableHeaderProps<T extends string> {
	label: string
	currentSortType: T
	sortTypeAsc: T
	sortTypeDesc: T
	onClick: (sortType: T) => void
	className?: string
	arrowPosition?: "left" | "right"
}

export function SortableTableHeader<T extends string>({
	label,
	currentSortType,
	sortTypeAsc,
	sortTypeDesc,
	onClick,
	className,
	arrowPosition = "right",
}: SortableTableHeaderProps<T>) {
	const isActive =
		currentSortType === sortTypeAsc || currentSortType === sortTypeDesc
	const isAsc = currentSortType === sortTypeAsc

	const handleClick = () => {
		if (currentSortType === sortTypeDesc) {
			onClick(sortTypeAsc)
		} else {
			onClick(sortTypeDesc)
		}
	}

	const ArrowIcon = isAsc ? ArrowUp : ArrowDown

	return (
		<button
			type="button"
			onClick={handleClick}
			className={cn(
				"flex items-center gap-1 hover:text-primary",
				arrowPosition === "left" && "ml-auto flex-row-reverse",
				className,
			)}
		>
			<span>{label}</span>
			{isActive && <ArrowIcon className="h-3 w-3" />}
		</button>
	)
}

interface NonSortableTableHeaderProps {
	label: string
	onClick?: () => void
	className?: string
}

export function NonSortableTableHeader({
	label,
	onClick,
	className,
}: NonSortableTableHeaderProps) {
	return (
		<button
			type="button"
			onClick={() => {
				if (onClick) {
					onClick()
				}
			}}
			className={cn("flex items-center gap-1", className)}
		>
			<span>{label}</span>
		</button>
	)
}
